type Props = {
  title: string;
  body: string;
  /** Optional concrete action to try. Rendered below the body with a divider. */
  tryThis?: string;
};

export function InsightCard({ title, body, tryThis }: Props) {
  return (
    <div
      className="border border-[color:var(--color-wren-border)] bg-white p-8"
      style={{
        borderRadius: "var(--radius-wren-card)",
        boxShadow: "var(--shadow-wren-button)",
      }}
    >
      <p className="wren-eyebrow mb-4 text-[0.75rem]">{title}</p>
      <p className="text-[1rem] leading-[1.5rem] text-[color:var(--color-wren-light-brown)]">
        {body}
      </p>
      {tryThis && (
        <>
          <hr className="my-6 border-t border-[color:var(--color-wren-border)]" />
          <p className="wren-eyebrow mb-2 text-[0.75rem]">Try this</p>
          <p className="text-[1rem] leading-[1.5rem] text-[color:var(--color-wren-light-brown)]">
            {tryThis}
          </p>
        </>
      )}
    </div>
  );
}
